<svelte:options tag='swc-validation-message' immutable={true} />

<script>

  export let message = '';

</script>

<style>
  div {
    color: #ee3541;
    font-size: 0.75em;
    margin-top: 6.5px;
    position: absolute;
  }
</style>

<div>{message}</div>
